// extracted by mini-css-extract-plugin
export default {"component":"JTJK_7","medium":"RF2Le1","active":"ohfd3S","large":"J3mfDR"};